import React, { useEffect } from 'react';
import {
    Grid, Menu, Breadcrumb, Tab, Label, Icon, Loader, Dimmer
} from 'semantic-ui-react'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import ListaPix from './ListaPix';
import Devolucao from './Devolucao';
import { pixListPixAction } from '../../actions/PixActions';

const styles = {
    itemMenu: {
        padding: '2em',
        background: '#b3d8e7',
        color: '#fff'
    }


    , menuTab: {
        padding: '0 0',
        backgroundColor: '#1884af',
        width: '100%',
        borderRadius: '30px',

    }

};

function Pix(props) {
    useEffect(() => {
        pixListPixAction();
    }, [])

    const { pixListPixAction } = props;
    const { listpix, userid } = props;
    let panes = [
        {
            menuItem: <Menu.Item key='TABpendente'><Icon name='money bill alternate outline' />Pix<Label color='green'>{listpix[0]?.pix_total}</Label></Menu.Item>,
            render: () =>
                <ListaPix />,
        },
    ]
    if (userid == 2 || userid == 3 || userid == 21 || userid == 79 || userid == 86 || userid == 8 || userid == 170 || userid == 183) {

        panes.push({
            menuItem: <Menu.Item key='TABconci'><Icon name='list alternate outline' />Devolução</Menu.Item>,
            render: () =>
                <Devolucao
                />
        })

    }

    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size="large" style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item >
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Pix</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>
            <div>
                <Grid columns={1} doubling>
                    <Grid.Column>
                        <Tab panes={panes} />
                    </Grid.Column>
                </Grid>
            </div>


            <style>{`

                /*-------------------------------*/
                /*Menu Superior*/


                .ui.menu>.item:last-child{
                    padding: 0 !important;
                }

                .ui.mini.menu>.item{
                    padding: 0;
                }

                .ui.breadcrumb .section {
                    padding: 1.5em 1.5em !important;
                }
                
                .ui.breadcrumb .section:first-child {
                    padding-right: 0 !important;
                    border-radius: 0 0 0 5px !important;
                }
                  

                .ui.breadcrumb .active.section {
                    display: inline-block !important;
                    background-color: #1884af !important;
                    color: #fff !important;
                }






            `}</style>


        </div>



    );
}

const mapStateToProps = (state) => ({
    listpix: state.PixReducer.listpix,
    userid: state.LoginReducer.userid
})
export default withRouter(connect(mapStateToProps, {
    pixListPixAction,
}
)(Pix));

//Seção de estilos


